import ArrowUpRightFromSquare from "./assets/arrow-up-right-from-square"
import BagShopping from "./assets/bag-shopping"
import CartShopping from "./assets/cart-shopping"
import SquareArrowUpRight from "./assets/square-arrow-up-right"

export const icons = [
  {
    title: "Amazon",
    prefix: "fab",
    iconName: "amazon"
  },
  {
    title: "Apple",
    prefix: "fab",
    iconName: "apple"
  },
  {
    title: "Bag Shopping",
    prefix: "fas",
    iconName: "bag-shopping"
  },
  {
    title: "Email",
    prefix: "fas",
    iconName: "envelope-open"
  },
  {
    title: "External Link",
    prefix: "fas",
    iconName: "arrow-up-right-from-square"
  },
  {
    title: "External Link Square",
    prefix: "fas",
    iconName: "square-arrow-up-right"
  },
  {
    title: "Bandcamp",
    prefix: "fab",
    iconName: "bandcamp"
  },
  {
    title: "Dev.to",
    prefix: "fab",
    iconName: "dev"
  },
  {
    title: "Discord",
    prefix: "fab",
    iconName: "discord"
  },
  {
    title: "Dribbble",
    prefix: "fab",
    iconName: "dribbble"
  },
  {
    title: "Etsy",
    prefix: "fab",
    iconName: "etsy"
  },
  {
    title: "Facebook",
    prefix: "fab",
    iconName: "facebook"
  },
  {
    title: "Facebook F",
    prefix: "fab",
    iconName: "facebook-f"
  },
  {
    title: "Github",
    prefix: "fab",
    iconName: "github"
  },
  {
    title: "Google Play",
    prefix: "fab",
    iconName: "google-play"
  },
  {
    title: "ID Card",
    prefix: "fas",
    iconName: "id-card"
  },
  {
    title: "Instagram",
    prefix: "fab",
    iconName: "instagram"
  },
  {
    title: "iTunes",
    prefix: "fab",
    iconName: "itunes-note"
  },
  {
    title: "LinkedIn",
    prefix: "fab",
    iconName: "linkedin"
  },
  {
    title: "LinkedIn In",
    prefix: "fab",
    iconName: "linkedin-in"
  },
  {
    title: "Link",
    prefix: "fas",
    iconName: "link"
  },
  {
    title: "Medium",
    prefix: "fab",
    iconName: "medium"
  },
  {
    title: "Newspaper",
    prefix: "fas",
    iconName: "newspaper"
  },
  {
    title: "Patreon",
    prefix: "fab",
    iconName: "patreon"
  },
  {
    title: "Pinterest",
    prefix: "fab",
    iconName: "pinterest-p"
  },
  {
    title: "Podcast",
    prefix: "fas",
    iconName: "podcast"
  },
  {
    title: "Reddit",
    prefix: "fab",
    iconName: "reddit-alien"
  },
  {
    title: "Shopping Cart",
    prefix: "fas",
    iconName: "cart-shopping"
  },
  {
    title: "Slack",
    prefix: "fab",
    iconName: "slack"
  },
  {
    title: "Snapchat",
    prefix: "fab",
    iconName: "snapchat"
  },
  {
    title: "Spotify",
    prefix: "fab",
    iconName: "spotify"
  },
  {
    title: "Soundcloud",
    prefix: "fab",
    iconName: "soundcloud"
  },
  {
    title: "Telegram",
    prefix: "fab",
    iconName: "telegram"
  },
  {
    title: "ThumbsUp",
    prefix: "fas",
    iconName: "thumbs-up"
  },
  {
    title: "TikTok",
    prefix: "fab",
    iconName: "tiktok"
  },
  {
    title: "Tumblr",
    prefix: "fab",
    iconName: "tumblr"
  },
  {
    title: "Threads",
    prefix: "fab",
    iconName: "threads"
  },
  {
    title: "Threads Square",
    prefix: "fab",
    iconName: "square-threads"
  },
  {
    title: "Twitch",
    prefix: "fab",
    iconName: "twitch"
  },
  {
    title: "Twitter",
    prefix: "fab",
    iconName: "twitter"
  },
  {
    title: "X",
    prefix: "fab",
    iconName: "x-twitter"
  },
  {
    title: "X Square",
    prefix: "fab",
    iconName: "square-x-twitter"
  },
  {
    title: "Vimeo",
    prefix: "fab",
    iconName: "vimeo"
  },
  {
    title: "Youtube",
    prefix: "fab",
    iconName: "youtube"
  }
]

export const svgIcons = [
  {
    name: "arrow-up-right-from-square",
    component: ArrowUpRightFromSquare
  },
  {
    name: "bag-shopping",
    component: BagShopping
  },
  {
    name: "cart-shopping",
    component: CartShopping
  },
  {
    name: "square-arrow-up-right",
    component: SquareArrowUpRight
  }
]
